import { render, staticRenderFns } from "./PickupRequest.vue?vue&type=template&id=53d3f2d4&"
import script from "./PickupRequest.js?vue&type=script&lang=js&"
export * from "./PickupRequest.js?vue&type=script&lang=js&"
import style0 from "./PickupRequest.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports